import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["template", "container"]

  add(event) {
    event.preventDefault()
    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime())
    this.containerTarget.insertAdjacentHTML("beforeend", content)
  }

  remove(event) {
    event.preventDefault()
    const wrapper = event.target.closest(".nested-fields")
    if (!wrapper) return

    // If it's a new record (created client-side) remove it entirely
    const isNew = wrapper.dataset.newRecord === "true" || wrapper.dataset.newRecord === true
    if (isNew) {
      wrapper.remove()
      return
    }

    // For persisted records, set _destroy and hide the wrapper
    const destroyField = wrapper.querySelector("input[name*='[ _destroy]'], input[name*='_destroy']")
    // more robust selector fallback:
    const fallback = wrapper.querySelector("input[type='hidden'][name$='[_destroy]']")
    const hidden = destroyField || fallback

    if (hidden) hidden.value = "1"
    wrapper.style.display = "none"
  }
}
